import { useMemo } from "react";
import { useProtocolStore } from "@/hooks";
import { formatAPYDecimals } from "@/utils";
import { calculateLockAPY } from "@/utils/apy";

interface UseLockedPositionAPYResult {
    apy: string;
    isAPYLoading: boolean;
}

export function useLockedPositionAPY(duration: number, depositAmount = 0): UseLockedPositionAPYResult {
    const { stats, farms, params, isLoading } = useProtocolStore();

    const apy = useMemo(() => {
        if (isLoading) return "0";
        const apyValue = calculateLockAPY(depositAmount, duration, { stats, farms, params });
        const locked7d =
            Object.values(stats.locked).find((liusd) => liusd.bucketMaturity === duration)?.average7dAPY ?? 0;
        return formatAPYDecimals(Math.max(apyValue, locked7d) * 100);
    }, [duration, depositAmount, stats, farms, params, isLoading]);

    return {
        apy,
        isAPYLoading: isLoading,
    };
}
